import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useTicketStatuss, TicketStatus } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<TicketStatus>
      useData={useTicketStatuss}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
